import { render } from "./LogoLoader.vue?vue&type=template&id=06244fc5&scoped=true"
import script from "./LogoLoader.vue?vue&type=script&lang=js"
export * from "./LogoLoader.vue?vue&type=script&lang=js"

import "./LogoLoader.vue?vue&type=style&index=0&id=06244fc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06244fc5"]])

export default __exports__